import { useEffect, useState } from 'react';
import { fetchFile } from 'services/api';

// Une balise <img> n'envoie PAS l'en-tete Authorization. Une image privee ne
// peut donc pas etre affichee par un simple src= : c'est exactement pourquoi
// les photos etaient CASSEES en prod (src -> /uploads/... derriere
// `authenticate` -> 401 systematique, image vide, sans erreur visible).
// On recupere le fichier avec le jeton, puis on affiche le Blob.
export default function ImageProtegee({ src, alt = '', style, className, fallback = null }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!src) { setUrl(null); return undefined; }
    let annule = false;
    let objectUrl = null;
    fetchFile(src)
      .then(blob => {
        if (annule) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      })
      .catch(() => { if (!annule) setUrl(null); });
    return () => { annule = true; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [src]);

  if (!url) return fallback;
  return <img src={url} alt={alt} style={style} className={className} />;
}
